import { userType } from "../../DTO";
import { createRoleType } from "../../DTO/roles";
import { Api } from "../api";

export const Create = (user: userType, rolesList: createRoleType) => {
    return new Promise<{ data: any }>((resolve, reject) => {
        const api = new Api({
            method: "post",
            path: "roles",
            header: {
                Authorization: "Bearer " + user?.access_token,
            },
            body: {
                name: rolesList?.name,
                permissions: rolesList?.permissions,
            },
        });
        return api
            .call()
            .then((data) => {
                return resolve({
                    data: data,
                });
            })
            .catch((err) => {
                return reject({ err });
            });
    });
};
